var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 90c-8.284 0-15-6.716-15-15v-45h-45c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15v60c0 8.284-6.716 15-15 15z",
    fill: "#07485e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 90c-8.284 0-15-6.716-15-15v-60c0-8.284 6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15h-45v45c0 8.284-6.716 15-15 15z",
    fill: "#09607d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 512h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h45v-45c0-8.284 6.716-15 15-15s15 6.716 15 15v60c0 8.284-6.716 15-15 15z",
    fill: "#07485e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 512h-60c-8.284 0-15-6.716-15-15v-60c0-8.284 6.716-15 15-15s15 6.716 15 15v45h45c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#09607d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.155 245.971c-1.15-1.279-28.676-31.674-73.24-62.329-59.576-40.981-121.443-62.642-178.915-62.642s-119.339 21.661-178.914 62.642c-44.564 30.655-72.09 61.05-73.24 62.329-5.128 5.703-5.128 14.355 0 20.059 1.15 1.279 28.676 31.674 73.24 62.329 59.575 40.98 121.443 62.641 178.914 62.641s119.339-21.661 178.914-62.642c44.564-30.655 72.09-61.05 73.24-62.329 5.128-5.703 5.128-14.355.001-20.058z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.155 245.971c-1.15-1.279-28.676-31.674-73.24-62.329-59.576-40.981-121.443-62.642-178.915-62.642v270c57.472 0 119.339-21.661 178.914-62.642 44.564-30.655 72.09-61.05 73.24-62.329 5.128-5.703 5.128-14.355.001-20.058z",
    fill: "#dfdef5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 391c-74.439 0-135-60.561-135-135s60.561-135 135-135 135 60.561 135 135-60.56 135-135 135z",
    fill: "#09607d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 121v270c74.439 0 135-60.561 135-135s-60.56-135-135-135z",
    fill: "#07485e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 321c-35.841 0-65-29.159-65-65s29.159-65 65-65 65 29.159 65 65-29.159 65-65 65z",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 191v130c35.841 0 65-29.159 65-65s-29.159-65-65-65z",
    fill: "#5f69e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewer);
export default __webpack_public_path__ + "static/media/viewer.8a06f935c97240fae142470e3776975e.svg";
export { ForwardRef as ReactComponent };